// src/components/ConflictResolutionToast.jsx (NEW FILE)

import React from "react";
import { toast } from "react-hot-toast";
import { BadgeAlert, Edit, Eye, X } from "lucide-react";
import moment from "moment";

const ConflictResolutionToast = ({
  t,
  conflictingItem,
  allItems,
  onNavigate,
}) => {
  // Find the other items that this one conflicts with
  const otherConflictingItems = allItems.filter(
    (item) =>
      item.is_conflicting &&
      item.id !== conflictingItem.id &&
      moment(conflictingItem.start_time).isBefore(item.end_time) &&
      moment(conflictingItem.end_time).isAfter(item.start_time)
  );

  return (
    <div className="bg-zinc-900 border border-amber-500/50 rounded-lg p-4 w-full max-w-sm shadow-lg text-white">
      <div className="flex items-start gap-3">
        <BadgeAlert className="text-amber-400 mt-1 flex-shrink-0" />
        <div className="flex-grow">
          <p className="font-bold">Time Conflict Detected</p>
          <p className="text-sm text-gray-400 mt-1">
            "{conflictingItem.title}" overlaps with:
          </p>
          <div className="mt-2 space-y-1">
            {otherConflictingItems.map((otherItem) => (
              <p
                key={otherItem.id}
                className="text-xs text-gray-300 font-mono p-1 bg-black/30 rounded"
              >
                - {otherItem.title}
              </p>
            ))}
          </div>
        </div>
        <button onClick={() => toast.dismiss(t.id)}>
          <X size={16} className="text-gray-500" />
        </button>
      </div>
      <div className="mt-4 grid grid-cols-2 gap-2 text-sm">
        <button
          onClick={() => {
            toast.dismiss(t.id);
            onNavigate(conflictingItem); // Navigate to manage the item the user clicked on
          }}
          className="bg-blue-500 text-white font-bold py-2 rounded-lg flex items-center justify-center gap-1.5 hover:bg-blue-600"
        >
          <Edit size={14} /> Reschedule This
        </button>
        {otherConflictingItems.length === 1 && (
          <button
            onClick={() => {
              toast.dismiss(t.id);
              onNavigate(otherConflictingItems[0]); // Navigate to manage the other item
            }}
            className="bg-gray-700 text-white font-bold py-2 rounded-lg flex items-center justify-center gap-1.5 hover:bg-gray-600"
          >
            <Eye size={14} /> View Other
          </button>
        )}
      </div>
    </div>
  );
};

export default ConflictResolutionToast;
